import { DataSourceMode, DataSourceModeChangeEvent } from "@mcleod/components";
import { UserUtil, WebPasswordChange } from "@mcleod/common";
import { AutogenLayoutDockUser } from "./autogen/AutogenLayoutDockUser";
import { UserType } from "@mcleod/core";

export class DockUser extends AutogenLayoutDockUser {
    override onLoad() {
        UserUtil.setAdminComponentVisibility(this.panelAdminButtons);
    }

    buttonSetWebPasswordOnClick() {
        const endpointPath = "lme/general/user/change-web-password";
        const userId = this.sourceUserSettings.activeRow.get("id", null);
        const userName = this.sourceUserSettings.activeRow.get("name", null);
        new WebPasswordChange(endpointPath, userId, userName).show();
    }

    sourceUserSettingsAfterModeChange(event: DataSourceModeChangeEvent) {
        this.buttonSetWebPassword.visible = event.newMode === DataSourceMode.UPDATE;

        if (event.newMode === DataSourceMode.ADD) {
            this.sourceUserSettings.activeRow?.set("web_user_type", UserType.DOCK);
            this.sourceUserSettings.activeRow?.set("is_dock_worker", 'Y');
            this.layoutLMEUserDockOperations.checkboxDockSupervisor.enabled = false;
        }

        if (event.newMode === DataSourceMode.ADD || event.newMode === DataSourceMode.UPDATE) {
            this.layoutLMEUserDockOperations.checkboxDockOperator.enabled = false;
        }
    }
}
